import React from 'react';
import { Text } from '@99designs/emu';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { Owner } from '@99designs/graph-utils/types';
import { DisplayName } from '../DisplayName';

function AuthorDisplay({ user }: { user: Owner }) {
    const { name, profile } = user;

    return (
        <Text fontFamily="attribution" size="size2" italic>
            <FormattedMessage
                message={__('by {user}')}
                values={{
                    user: <DisplayName displayName={name} profileUrl={profile} />,
                }}
            />
        </Text>
    );
}

export default AuthorDisplay;
